 
 
 
 
 
 
define(['http', './utils', 'security', 'endpoints', '../requester/urlBuilder', '../services/routing/routingParameters'],
    function(http, utils, security, endpoints, urlBuilder, routingParameters) {
        'use strict';

        var queryParamNames = Object.keys(routingParameters(['avoid', 'vehicleLoadType', 'locations',
                'supportingPoints', 'avoidVignette', 'allowVignette', 'avoidAreas', 'sectionType'])),
            maxNoOfElementsInBatchRequest = 100;

        function convertPointToLatitudeLongitude(point) {
            var splitPoint = point.split(',');

            return {
                latitude: splitPoint[0],
                longitude: splitPoint[1]
            };
        }

        function prepareSupportingPoints(supportingPoints) {
            return supportingPoints.map(convertPointToLatitudeLongitude);
        }

        function prepareAreas(areas) {
            return {
                rectangles: areas.map(function(area) {
                    return {
                        southWestCorner: convertPointToLatitudeLongitude(area.southWestCorner),
                        northEastCorner: convertPointToLatitudeLongitude(area.northEastCorner)
                    };
                })
            };
        }

        function addBodyParamIfNeeded(request, paramName, paramValue) {
            request.bodyParameters = request.bodyParameters || {};
            if (paramValue !== undefined) {
                request.bodyParameters[paramName] = paramValue;
            }
        }

        return {
            calculateRoute: function(options, callback) {
                var pathParams = {},
                    queryParams = {},
                    request;

                queryParams.key = utils.or(options.key, security.getKey('services/routing'));

                pathParams.locations = utils.required(options.locations);

                // language
                queryParams.language = options.language || 'en-GB';

                // look for not required passed params and set them if they are not undefined
                utils.extractQueryParams(options, queryParams, queryParamNames);

                if (queryParams.vehicleEngineType === 'electric') {
                    if (queryParams.constantSpeedConsumptionInkWhPerHundredkm) {
                        queryParams.constantSpeedConsumptionInkWhPerHundredkm =
                            options.constantSpeedConsumptionInkWhPerHundredkm.join(':');
                    }
                } else if (queryParams.constantSpeedConsumptionInLitersPerHundredkm) {
                    queryParams.constantSpeedConsumptionInLitersPerHundredkm =
                        options.constantSpeedConsumptionInLitersPerHundredkm.join(':');
                }

                if (options.avoid) {
                    queryParams.avoid = options.avoid;
                }
                if (options.vehicleLoadType) {
                    queryParams.vehicleLoadType = options.vehicleLoadType;
                }
                if (options.sectionType) {
                    queryParams.sectionType = options.sectionType;
                }

                request = {
                    url: '{protocol}://' + endpoints.routing,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callbackParam: 'callback',
                    callback: callback,
                    fail: options.fail
                };

                addBodyParamIfNeeded(request, 'supportingPoints', options.supportingPoints &&
                    prepareSupportingPoints(options.supportingPoints));

                addBodyParamIfNeeded(request, 'avoidAreas', options.avoidAreas &&
                    prepareAreas(options.avoidAreas));

                addBodyParamIfNeeded(request, 'allowVignette', options.allowVignette);
                addBodyParamIfNeeded(request, 'avoidVignette', options.avoidVignette);

                if (Object.keys(request.bodyParameters).length > 0) {
                    http.post(request);
                } else {
                    http.get(request);
                }
            },

            calculateReachableRange: function(options, callback) {

                var pathParams = {},
                    queryParams = {},
                    calculateRouteQueryParamNames = ['fuelBudgetInLiters', 'energyBudgetInkWh', 'timeBudgetInSec'];

                queryParams.key = utils.or(options.key, security.getKey('services/routing'));

                pathParams.origin = utils.required(options.origin);

                // look for not required passed params and set them if they are not undefined
                utils.extractQueryParams(options, queryParams, calculateRouteQueryParamNames.concat(queryParamNames));

                if (queryParams.vehicleEngineType === 'electric') {
                    queryParams.constantSpeedConsumptionInkWhPerHundredkm =
                        options.constantSpeedConsumptionInkWhPerHundredkm.join(':');
                } else {
                    queryParams.constantSpeedConsumptionInLitersPerHundredkm =
                        options.constantSpeedConsumptionInLitersPerHundredkm.join(':');
                }

                if (options.avoid) {
                    queryParams.avoid = options.avoid;
                }
                if (options.vehicleLoadType) {
                    queryParams.vehicleLoadType = options.vehicleLoadType;
                }

                http.get({
                    url: '{protocol}://' + endpoints.reachableRange,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callbackParam: 'callback',
                    callback: callback,
                    fail: options.fail
                });
            },

            batch: function(options, callback) {
                var queryParams = {},
                    bodyParams = {},
                    rawBatchItems,
                    batchItemQueryParamNames = queryParamNames.concat('avoid', 'vehicleLoadType'),
                    endpoint;

                queryParams.key = utils.or(options.key, security.getKey('services/routing'));

                rawBatchItems = utils.required(options.batchItems);

                bodyParams.batchItems = rawBatchItems.map(function(item) {
                    var pathParams = {}, itemParams = {}, query;
                    pathParams.locations = utils.required(item.locations);
                    pathParams.contentType = 'json';
                    utils.extractQueryParams(item, itemParams, batchItemQueryParamNames);
                    itemParams.language = utils.or(item.language, options.language || 'en-GB');

                    query = urlBuilder(endpoints.batchRoutingQuery, pathParams, itemParams);

                    return {query: query};
                });

                endpoint = bodyParams.batchItems.length <= maxNoOfElementsInBatchRequest ?
                    endpoints.batchSyncRouting : endpoints.batchRouting;

                http.post({
                    url: '{protocol}://' + endpoint,
                    queryParameters: queryParams,
                    bodyParameters: bodyParams,
                    callbackParam: 'callback',
                    callback: callback,
                    fail: options.fail
                });
            },

            matrix: function(options, callback) {
                var queryParams = {},
                    bodyParams = {},
                    endpoint;
                queryParams.key = utils.or(options.key, security.getKey('services/routing'));

                utils.extractQueryParams(options, queryParams, queryParamNames);

                bodyParams.origins = utils.required(options.origins);
                bodyParams.destinations = utils.required(options.destinations);

                endpoint = bodyParams.origins.length * bodyParams.destinations.length <= maxNoOfElementsInBatchRequest ?
                    endpoints.matrixSyncRouting : endpoints.matrixRouting;

                http.post({
                    url: '{protocol}://' + endpoint,
                    queryParameters: queryParams,
                    bodyParameters: bodyParams,
                    callbackParam: 'callback',
                    callback: callback,
                    fail: options.fail
                });
            }
        };
    });



// WEBPACK FOOTER //
// ./rest/routing.js